<template>
  <div
    :class="{
      page: true,
      graphic: true,
      overlayed: showInformation,
      large: large,
    }"
    ref="page"
    v-bind:style="{ transform: `scale(${scale})`,
      maxWidth: large && isMaxWidth ? `${widthMax}` : null,
      minWidth: isMinWidth ? `${widthMin}` : null,
    }"
  >
    <span v-if="isLoaded">
      <div>
        <img v-if="scene.type === 'home'" class="page__bg" :src="infographics.backgroundImage" alt />
      </div>
      <div class="page__inner">
        <header class="page__header">
          <div class="page__info">
            <div>
              <h1
                class="page__title"
                v-if="true"
                v-html="scene.title[lang]"
                :key="scene.title['de'] + scene"
              />
            </div>
            <div>
              <div
                class="page__subtitle"
                v-if="true"
                v-html="scene.subtitle[lang]"
                :key="scene.subtitle['de'] + scene"
              />
            </div>
            <div class="page__information-pane" v-if="scene.information">
              <div>
                <button
                  class="page__info--button"
                  v-if="showInformation === false && isHomepage"
                  :key="scene.information.title['de'] + scene"
                  @click="showInformation = true"
                >{{ lang === 'en' ? "More Information" : "Mehr Erfahren" }}</button>
              </div>
              <div>
                <div
                  class="page__information-content"
                  v-if="showInformation || !isHomepage"
                  :key="scene.information.title['de'] + scene"
                >
                  <div class="page__information-content__inner">
                    <div
                      class="page__information-content__title"
                      v-html="scene.information.title[lang]"
                    ></div>
                    <div class="page__information-content__body">
                      <div v-html="scene.information.text[lang]" />
                      <button v-if="isHomepage" @click="showInformation = false" class="close" />
                    </div>
                    <div
                      class="page__information-content__links"
                      v-if="scene.information.links && scene.information.links[lang]"
                    >
                      <a
                        v-for="link in scene.information.links[lang]"
                        :href="link.url"
                        :key="link.url"
                        target="_blank"
                      >{{link.text}}</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <img :src="logoSrc" class="page__logo" />
        </header>
        <div class="page__scenes">
          <div>
            <div v-if="scene.type === 'home'">
              <div class="page__row">
                <div class="page__scene">
                  <Scene
                    :scene="scenes[0]"
                    :sceneId="scene._id"
                    :editable="true"
                    :previewList="previewList"
                  />
                </div>
              </div>
              <div class="page__row">
                <div class="page__scene">
                  <Scene
                    :scene="scenes[1]"
                    :sceneId="scene._id"
                    :editable="true"
                    :previewList="previewList"
                  />
                </div>
                <div class="page__scene">
                  <Scene
                    :scene="scenes[2]"
                    :sceneId="scene._id"
                    :editable="true"
                    :previewList="previewList"
                  />
                </div>
              </div>
            </div>
          </div>
          <div>
            <Scene
              v-if="scene.type === 'scene'"
              :sceneId="scene._id"
              :scene="scene"
              :editable="true"
              :previewList="previewList"
            />
          </div>
          <div>
            <Scene
              v-if="scene.type === 'subscene'"
              :sceneId="scene._id"
              :scene="scene"
              :editable="true"
              :previewList="previewList"
            />
          </div>
        </div>
        <footer class="page__footer">
          <div class="page__footer-btn">
            <div class="page__home-btn" v-if="!isHomepage">{{ btnHome[lang] }}</div>
            <div class="page__back-btn" v-if="!isHomepage">{{ btnText[lang] }}</div>
          </div>
          <div class="page__lang">
            <LangSwitcher />
          </div>
        </footer>
        <SocialShare />
        <div>
          <div v-if="showInformation" class="overlay" />
        </div>
      </div>
    </span>
  </div>
</template>

<script>
import { mapMutations, mapState, mapGetters } from "vuex";

import LangSwitcher from "@/components/LangSwitcher";
import SocialShare from "@/components/SocialShare";
import Scene from "@/components/Infographics/Scene";

import MainLogo from "@/assets/logo.svg";

import api from "../../api";

export default {
  data() {
    return {
      isLoaded: false,
      showInformation: false,
      scale: 1,
      large: false,
      widthMax: "auto",
      widthMin: "auto",
      isMinWidth: false,
      isMaxWidth: false,
      btnText: {
        en: "Back",
        de: "Zurück"
      },
      btnHome: {
        en: "Home",
        de: "Start"
      },
      codeText: {
        en: "More info:",
        de: "Mehr info:"
      }
    };
  },
  computed: {
    ...mapState([
      "infographics",
      "lang",
      "infographicsScenes",
      "selectedScene",
      "selectedProject",
      "unsavedScenes"
    ]),
    ...mapGetters([
      "getInfographics",
      "getSelectedScene",
      "getSelectedProject"
    ]),
    scenes() {
      return this.getInfographics.scenes.filter(
        scene => scene.type === "scene"
      );
    },
    isHomepage() {
      return this.scene && this.scene === "home";
    },
    isUnsaved() {
      return this.unsavedScenes.find(s => s._id === this.scene._id) || false;
    },
    logoSrc() {
      return MainLogo;
    }
  },
  props: {
    scene: Object,
    previewList: {
      type: Boolean,
      dufault: false
    }
  },
  methods: {
    ...mapMutations([
      "setInfographics",
      "setSelectedProject",
      "setSelectedScene",
      "changeScene"
    ]),
    scaling() {
      const { width } = this.$el.parentElement.getBoundingClientRect();
      this.scale = (width / 1000) * 0.5207;
      const height = 1080 * this.scale;
      this.$el.parentElement.style.height = `${height}px`;
    }
  },
  mounted() {
    const bus = this;

    api.projects.loadProjectById(this.$route.params.id).then(project => {
      this.setInfographics(project.data);
      this.isLoaded = true;
    });

    this.$on("rerender", function(msg) {
      console.log("IS RE RENDER");

      bus.$forceUpdate();
    });

    this.scaling();

    window.addEventListener("resize", this.scaling);
  },
  destroyed() {
    window.removeEventListener("resize", this.scaling);
  },
  components: {
    LangSwitcher,
    SocialShare,
    Scene
  }
};
</script>

<style lang="scss" scoped>
.abs-scene {
  position: absolute;
}

.overlay {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  opacity: 0.6;
  background-color: #b2c6d2;
  z-index: 9;
  transition: 0.6s ease;
}

.fade-in-overlay {
  &-enter,
  &-leave-to {
    opacity: 0;
  }

  &-enter-to,
  &-leave {
    opacity: 0.6;
  }
}

.page {
  // background: #2789AF;
  min-width: 1920px;
  min-height: 1080px;
  height: 100%;
  width: 100%;
  position: relative;
  overflow: hidden;
  transform-origin: 0 0;

  &.large {
    max-height: 1080px;
    min-width: auto;
  }

  &__inner {
    height: 100%;
    // max-width: 1920px;
    // min-width: 1024px;
    // min-height: 1080px;
  }

  &.overlayed {
    .page__header {
      z-index: 10;
    }
  }

  &.graphic {
    background: url("~@/assets/bg-inner.jpg") no-repeat center;
    background-size: cover;
  }

  &__bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  &__header {
    background: url("~@/assets/title-bg.svg") bottom left no-repeat;
    background-size: cover;
    height: 320px;
    padding: 75px;
  }

  &__info {
    max-width: 730px;
  }

  &__title {
    color: #004169;
    font-size: 55px;
    line-height: 66px;
    margin: 0;
    margin-bottom: 20px;
    text-transform: uppercase;
  }

  &__subtitle {
    font-size: 28px;
    letter-spacing: 0.021em;
    color: #ffffff;
    font-weight: 500;
  }

  &__information {
    &-pane {
      position: absolute;
      bottom: 0;
      left: 0;
      // margin-top: 0;
      max-width: 580px;
      width: 580px;
      height: calc(100% - 325px);
      z-index: 10;

      // .page.home & {
      //   top: 310px;
      // }
    }

    &-content {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      padding: 30px 75px 0;
      background: linear-gradient(
        160deg,
        rgba(255, 255, 255, 0.5) 0%,
        rgba(255, 255, 255, 0.5) 80%,
        transparent 80%,
        transparent 100%
      );
      z-index: 10;

      &__inner {
        overflow-y: overlay;
        max-height: 550px;
        min-height: 420px;
      }

      &::after {
        // content: "";
        position: absolute;
        left: 0;
        right: 0;
        border-left: 0 solid transparent;
        border-right: 590px solid transparent;
        bottom: auto;
        top: 100%;
        border-bottom: none;
        // border-top: 240px solid rgba(255, 255, 255, 0.25);
      }

      .page.overlayed & {
        // background-color: rgba(255, 255, 255, 0.75);
      }

      .page.overlayed &::after {
        // border-top: 240px solid rgba(255, 255, 255, 0.75);
      }

      .close {
        position: absolute;
        right: 32px;
        top: 32px;
        width: 32px;
        height: 32px;
        opacity: 0.3;
        border: none;
        background: none;
        outline: none;
        cursor: pointer;

        &:hover {
          opacity: 1;
        }

        &:before,
        &:after {
          position: absolute;
          top: 0;
          left: 15px;
          content: " ";
          height: 33px;
          width: 2px;
          background-color: #333;
        }

        &:before {
          transform: rotate(45deg);
        }

        &:after {
          transform: rotate(-45deg);
        }
      }

      &__title {
        margin-bottom: 20px;
        font-size: 28px;
        letter-spacing: 0.021em;
        color: #1881c0;
      }

      &__body {
        margin-bottom: 20px;
        font-size: 22px;
        color: #004169;
      }

      &__links {
        margin-bottom: 20px;

        a {
          display: inline-block;
          margin-top: 5px;
          font-size: 22px;
          color: #1881c0;
        }
      }
    }
  }

  .page.home {
    .page__scenes {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 220px;
      margin-top: 0;
    }
  }

  &__logo {
    position: absolute;
    right: 0;
    top: 75px;
    z-index: 1;
    cursor: pointer;
  }

  &__scenes {
    position: relative;
    margin-top: -105px;
    height: calc(100% - 236px);
  }

  &__row {
    margin-top: -50px;
    text-align: center;
  }

  &__scene {
    display: inline-block;

    & + & {
      margin-left: 175px;
    }
  }

  &__lang {
    position: absolute;
    right: 65px;
    bottom: 70px;
  }

  &__footer-btn {
    position: absolute;
    left: 65px;
    bottom: 70px;
    display: flex;
  }

  &__back-btn, &__home-btn {
    position: static;
    color: #ffffff;
    font-size: 28px;
    text-decoration: none;
    padding-left: 30px;
    min-height: 30px;
    cursor: pointer;
    z-index: 11;

    &::before {
      content: "";
      display: inline-block;
      width: 36px;
      height: 42px;
      background: url("~@/assets/back-button.svg") no-repeat center;
      background-size: cover;
      margin-top: -5px;
      margin-right: 15px;
      vertical-align: middle;
    }
  }

  &__home-btn {
    &::before {
      content: "";
      display: inline-block;
      width: 42px;
      height: 36px;
      background: url("~@/assets/home-button.svg") no-repeat center;
      background-size: cover;
      margin-top: -5px;
      margin-right: 15px;
      vertical-align: middle;
    }
  }

  &__code {
    position: absolute;
    left: 75px;
    bottom: 70px;
    color: #ffffff;
    font-size: 14px;

    .label {
      margin-bottom: 5px;
    }
  }
}

[data-name^="PULSE"] {
  // animation-name: pulse;
  // animation-duration: 3s;
  // animation-timing-function: ease-in;
  // animation-direction: alternate;
  // animation-iteration-count: infinite;
}

@keyframes pulse {
  0% {
    opacity: 0.3;
  }
  100% {
    opacity: 1;
  }
}

.slide-enter {
  opacity: 0;
}

.page__info--button {
  position: relative;
  display: inline-block;
  word-wrap: break-word;
  text-align: left;
  font-size: 30px;
  left: 70px;
  color: #004169;
  font-weight: 500;
  min-height: -5px;
  padding: 15px 35px 15px 80px;
  background: url("~@/assets/flag-modal.svg") no-repeat right center;
  background-size: contain;
  white-space: nowrap;
  border: none;
  cursor: pointer;

  &::after {
    content: "";
    position: absolute;
    width: 69px;
    height: 69px;
    top: -4px;
    left: -10px;
    background: url("~@/assets/info-icon.svg") no-repeat right center;
  }
}
</style>